import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IVipIconProps extends ISvgIconProps {

}

export class VipIcon extends React.Component<IVipIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M11.01,8.495l-2.686,7.314H6.543L3.857,8.495h1.571l2.01,5.81l2-5.81H11H11.01z"/>
                    <path d="M13.352,8.495v7.314h-1.467V8.495H13.352z"/>
                    <path d="M19.858,11.857c-0.181,0.343-0.476,0.619-0.867,0.829c-0.391,0.21-0.895,0.314-1.495,0.314h-1.229v2.809h-1.467V8.495h2.695
                        c0.562,0,1.048,0.095,1.448,0.295s0.695,0.467,0.895,0.81c0.2,0.343,0.295,0.733,0.295,1.162
                        C20.134,11.152,20.039,11.523,19.858,11.857z M18.334,11.542c0.2-0.181,0.295-0.448,0.295-0.781c0-0.714-0.4-1.067-1.191-1.067
                        h-1.162v2.124h1.162c0.41,0,0.705-0.095,0.905-0.276H18.334z"/>
                    <rect x="2" y="4.476" width="20" height="0.762"/>
                    <rect x="2" y="18.762" width="20" height="0.762"/>
                    {/* <path d="M11.042,8.637l-2.816,7.678h-1.87L3.54,8.637h1.646l2.112,6.1l2.1-6.1H11.042z M13.506,8.637v7.678h-1.54V8.637H13.506z
                        M20.623,11.015c0.002,0.403-0.099,0.801-0.292,1.155c-0.21,0.375-0.528,0.678-0.913,0.869c-0.488,0.236-1.026,0.349-1.567,0.33
                        h-1.287v2.946h-1.54V8.637h2.827c0.523-0.015,1.042,0.09,1.518,0.308c0.392,0.181,0.72,0.476,0.941,0.847
                        C20.522,10.164,20.63,10.586,20.623,11.015z M17.786,12.124c0.341,0.028,0.68-0.077,0.946-0.292
                        c0.106-0.107,0.188-0.236,0.241-0.377c0.053-0.141,0.076-0.292,0.067-0.442c0-0.748-0.418-1.122-1.254-1.122h-1.222v2.233H17.786z"
                        />
                    <path d="M22.587,5.565h-21v-1.5h21V5.565z"/>
                    <path d="M22.587,20.565h-21v-1.5h21V20.565z"/> */}
                </g>
            </SvgIcon>
        );
    }
}
